document.querySelectorAll('.case-results-slider').forEach(slider => {
    const controls = slider.closest('.case-results-slider-container').querySelector('.case-results-slider__controls');
    const itemsPerPage = parseInt(slider.closest('[data-items-per-page]').getAttribute('data-items-per-page'), 10) || 1;
    const gutter = parseInt(slider.closest('[data-gutter]').getAttribute('data-gutter'), 10) || 1;
    let breakpoint = itemsPerPage;
    if(itemsPerPage >= 1) {
      breakpoint = 2;
    }
    tns({
      container: slider,
      items: 1,
      nav: false,
      controlsPosition: 'bottom',
      autoplay: false,
      center: true,
      controlsContainer: controls,
      responsive: {
          768:{
          items: breakpoint,
          gutter: gutter,
          center: false
          },
          900: {
            items: itemsPerPage,
            gutter: gutter,
            center: false
          }
      }
  });
});